/*
 * List of e-wallet
 */
export const DIGITAL_WALLET = ["ovo", "dana", "doku", "linkaja", "shopeepay", "gopay"];

/*
 * Banks that hidden from sender bank options
 */
export const HIDDEN_BANKS = [
  "e2pay",
  "dtk",
  "dutamoney",
  "saldo_flip",
  "bri_syr",
  "midtrans",
  "billfazz",
  "btn",
  "indomaret",
  "super_bank",
  "kesejahteraan_ekonomi",
  "superflip",
  ...DIGITAL_WALLET
];

/*
 * Virtual Accounts Banks that hidden from topup options
 */
export const HIDDEN_TOPUP_VA_BANKS = [
  "bri_va",
  "permata_va",
  "cimb_va",
  "mandiri_va",
  "muamalat_va",
  "danamon_va",
  "bca_va",
  "shopeepay_va"
];

/*
 * Banks that hidden from create topup radio buttons
 */
export const TOPUP_HIDDEN_BANKS = ["mega", ...HIDDEN_BANKS, ...DIGITAL_WALLET, ...HIDDEN_TOPUP_VA_BANKS];

/*
 * Banks that hidden from all sender banks
 */
export const DISABLED_BANKS_IN_PERIOD = {};

/*
 * Banks that hidden from create topup radio buttons for certain period
 */
export const TOPUP_DISABLED_BANKS_IN_PERIOD = {};

/*
 * Some banks that are no longer supported from BE
 */
export const REMOVED_TRANSACTION_BANKS_HISTORY = [
  "danamon_syr",
  "atmb_lsb",
  "atmb_plus",
  "e2pay",
  "dtk",
  "dutamoney",
  "saldo_flip",
  "finnet",
  "dompetku",
  "doku",
  "admin",
  "gv",
  "tokopedia",
  "midtrans",
  "billfazz",
  "gopay_driver",
  "bni_cc",
  "bri_cc",
  "cimb_cc",
  "danamon_cc",
  "permata_cc",
  "mandiri_cc",
  "hsbc_cc",
  "ocbc_cc",
  "maybank_cc",
  "mega_cc",
  "uob_cc",
  "bukopin_cc",
  "dbs_cc",
  "mayapada_cc",
  "hana_cc",
  "mnc_internasional_cc",
  "muamalat_cc",
  "panin_cc",
  "sahabat_sampoerna_cc",
  "standard_chartered_cc",
  "indomaret",
  "sakuku",
  "superflip",
  "commonwealth"
];

export const REMOVED_TRANSACTION_BANKS = [...REMOVED_TRANSACTION_BANKS_HISTORY, "bri_syr", "btn_syr"];

export const OVERRIDE_BANKS_NAME = [
  { bank_code: "victoria_syr", bank_name: "Victoria Syariah / Bank Syariah Nasional" }
];
/*
 * VA Banks in multi input transaction
 */
export const HIDDEN_VA_BANKS = ["bca_va", "shopeepay_va"];

/*
 * Big Flip Deposit object
 */
export const BIGFLIP_DEPOSIT = {
  deposit: [
    {
      bank_code: "Deposit",
      bank_name: "Deposit"
    },
    {
      bank_code: "deposit",
      bank_name: "Deposit"
    }
  ]
};

export const FFB_COA = {
  coa: [
    {
      bank_code: "coa",
      bank_name: "Flip for Business"
    },
    {
      bank_code: "coa",
      bank_name: "Flip for Business"
    }
  ]
};

/**
 * invalid bank
 */
export const INVALID_BENEFICIARY_BANK = ["BRI (Bank Rakyat Indonesia) Syariah", "Commonwealth Bank"];

/**
 * for whitelisting the beneficiary banks
 */
export const WHITELISTED_BENEFICIARY_BANKS = [
  // Banks
  "mandiri",
  "bri",
  "bni",
  "bca",
  "bsm",
  "cimb",
  "muamalat",
  "danamon",
  "permata",
  "bii",
  "panin",
  "uob",
  "ocbc",
  "citibank",
  "artha",
  "tokyo",
  "dbs",
  "standard_chartered",
  "capital",
  "anz",
  "boc",
  "bumi_arta",
  "hsbc",
  "rabobank",
  "mayapada",
  "bjb",
  "dki",
  "daerah_istimewa",
  "jawa_tengah",
  "jawa_timur",
  "jambi",
  "sumut",
  "sumatera_barat",
  "riau_dan_kepri",
  "sumsel_dan_babel",
  "lampung",
  "kalimantan_selatan",
  "kalimantan_barat",
  "kalimantan_timur",
  "kalimantan_tengah",
  "sulselbar",
  "sulut",
  "nusa_tenggara_barat",
  "bali",
  "nusa_tenggara_timur",
  "maluku",
  "papua",
  "bengkulu",
  "sulawesi",
  "sulawesi_tenggara",
  "nusantara_parahyangan",
  "india",
  "mestika_dharma",
  "sinarmas",
  "maspion",
  "ganesha",
  "icbc",
  "qnb_kesawan",
  "btn",
  "woori",
  "tabungan_pensiunan_nasional",
  "bri_syr",
  "bjb_syr",
  "mega",
  "bukopin",
  "jasa_jakarta",
  "hana",
  "mnc_internasional",
  "agroniaga",
  "sbi_indonesia",
  "royal",
  "nationalnobu",
  "mega_syr",
  "ina_perdana",
  "sahabat_sampoerna",
  "kesejahteraan_ekonomi",
  "bca_syr",
  "artos",
  "mayora",
  "index_selindo",
  "victoria_internasional",
  "agris",
  "chinatrust",
  "ccb",
  "victoria_syr",
  "banten",
  "mutiara",
  "panin_syr",
  "aceh",
  "btpn_syr",
  "dinar",
  "harda",
  "mas",
  "prima",
  "yudha_bakti",
  "shinhan",
  "bukopin_syr",
  "cnb",
  "antardaerah",
  "mantap",
  "eka",
  "aladin",
  "permata_syr",
  "jawa_timur_syr",
  "sinarmas_syr",
  "jawa_tengah_syr",
  "dki_syr",
  "bii_syr",
  "ocbc_syr",
  "daerah_istimewa_syr",
  "jambi_syr",
  "sumut_syr",
  "sumatera_barat_syr",
  "sumsel_dan_babel_syr",
  "kalimantan_selatan_syr",
  "kalimantan_barat_syr",
  "kalimantan_timur_syr",
  "sulselbar_syr",
  "artos_syr",
  "resona_perdania",
  "america_na",
  "jpmorgan_chase",
  "mizuho",
  "bnp_paribas",
  "amar",
  "btn_syr",
  "super_bank",
  "krom",
  "deutsche",
  "saqu",

  // VA
  "bni_va",
  "bri_va",
  "permata_va",
  "cimb_va",
  "mandiri_va",
  "muamalat_va",
  "danamon_va",
  "bca_va",

  // E-Wallets
  "linkaja",
  "gopay",
  "ovo",
  "dana",
  "shopeepay"
];

export const WHITELISTED_SENDER_BANKS = [
  "mandiri",
  "bri",
  "bni",
  "bca",
  "bsm",
  "cimb",
  "muamalat",
  "danamon",
  "permata",
  "dbs",
  "dki",
  "tabungan_pensiunan_nasional",
  "bni_va",
  "gopay_driver"
];

export const WHITELISTED_SENDER_BANKS_ONLY_BANKS = [
  "mandiri",
  "bri",
  "bni",
  "bca",
  "bsm",
  "cimb",
  "muamalat",
  "danamon",
  "permata",
  "dbs",
  "btn",
  "tabungan_pensiunan_nasional"
];
